/**
 * @desc 时效设置-保存sku时效
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: defs.basics.TimelinessSettingRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/timelinessSetting/skuSave`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
